var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClothes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_1144)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_801_1144)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_801_1144",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0H0V36H36V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_801_1144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5089 8.62021L27.558 4.64797L27.5496 4.64376C27.5272 4.6314 27.5044 4.61981 27.4813 4.60902C27.4703 4.60382 27.4596 4.59819 27.4486 4.59341C27.4275 4.58427 27.4059 4.57654 27.3844 4.56866C27.3703 4.56346 27.3567 4.55783 27.3426 4.55319C27.3257 4.54799 27.3084 4.54391 27.2913 4.53913C27.2719 4.53393 27.2525 4.5283 27.2328 4.52422C27.2207 4.52169 27.2082 4.52001 27.1959 4.5179C27.171 4.51326 27.146 4.50946 27.1208 4.50651C27.111 4.50538 27.1009 4.5051 27.0909 4.5044C27.0633 4.50196 27.0356 4.50055 27.0079 4.50018C27.0052 4.50018 27.0027 4.49976 26.9999 4.49976H22.4999C22.2015 4.49976 21.9154 4.61828 21.7044 4.82926C21.4934 5.04024 21.3749 5.32639 21.3749 5.62476C21.3749 6.51986 21.0193 7.37831 20.3864 8.01124C19.7535 8.64418 18.895 8.99976 17.9999 8.99976C17.1048 8.99976 16.2464 8.64418 15.6134 8.01124C14.9805 7.37831 14.6249 6.51986 14.6249 5.62476C14.6249 5.32639 14.5064 5.04024 14.2954 4.82926C14.0844 4.61828 13.7983 4.49976 13.4999 4.49976H8.99976C8.99611 4.49976 8.99273 4.50032 8.98908 4.50032C8.96537 4.50073 8.94169 4.50191 8.91806 4.50383C8.90428 4.50482 8.89036 4.50524 8.87672 4.50679C8.85548 4.50918 8.83425 4.51297 8.81301 4.51663C8.79698 4.51916 8.78095 4.52127 8.7652 4.52465C8.74861 4.52816 8.73244 4.53308 8.71598 4.5373C8.69587 4.54251 8.67562 4.54743 8.65594 4.55376C8.64384 4.55755 8.63203 4.56247 8.62022 4.56683C8.59659 4.57527 8.57325 4.58371 8.55047 4.59355C8.5402 4.59805 8.53022 4.6034 8.52009 4.60832C8.49633 4.61957 8.4727 4.63096 8.44992 4.64376L8.44148 4.64797L1.49067 8.62021C0.991548 8.90576 0.620624 9.3715 0.454001 9.92186C0.287377 10.4722 0.337687 11.0655 0.594609 11.5799L3.18267 16.7561C3.36838 17.1307 3.65534 17.4458 4.01103 17.6657C4.36671 17.8855 4.77688 18.0013 5.19501 17.9999H7.87476V29.2499C7.87543 29.8464 8.1127 30.4183 8.53451 30.8401C8.95633 31.262 9.52823 31.4992 10.1248 31.4999H25.8748C26.4713 31.4992 27.0432 31.262 27.465 30.8401C27.8868 30.4183 28.1241 29.8464 28.1248 29.2499V17.9999H30.8045C31.2227 18.0013 31.6328 17.8855 31.9885 17.6657C32.3442 17.4458 32.6312 17.1307 32.8169 16.7561L35.4051 11.5798C35.662 11.0653 35.7123 10.4721 35.5456 9.92169C35.379 9.37133 35.008 8.90574 34.5089 8.62021ZM5.19501 15.7499L2.60695 10.5735L7.87476 7.56355V15.7499H5.19501ZM30.8045 15.7499H28.1248V7.56341L33.3926 10.5736L30.8045 15.7499Z",
    fill: "#00067E"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_1144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_801_1144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothes);
export default __webpack_public_path__ + "static/media/clothes.ccade88fecc86a5d093e03f43feb884f.svg";
export { ForwardRef as ReactComponent };